import { get, post, put, remove } from "../https.js";

export const ApiGetMaintenance = {
  get: () => {
    return get(`/ores/getanncmnt`);
  },
};
